<template>
  <div>
    <slot></slot>
    <div class="tips"><i class="el-icon-warning"></i> 本功能仅支持购买按次数收费的接口，授权接口请联系客服购买。</div>
    <el-card class="box-card">
      <div class="SelectPackage">
        请选择接口：
      </div>
      <div>
        <el-select
          style=" width: 400px;margin-bottom: 16px;"
          v-model="apiKeyword"
          filterable
          clearable
          remote
          placeholder="请输入接口名称进行搜索"
          :remote-method="getSearch"
          :loading="loading"
          @change="getRechargePackage"
          @input="getSearch($event)"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.id"
          >
          </el-option>
        </el-select>

      </div>
      <div class="SelectPackage">
        请选择套餐
      </div>
      <div class="money">
        <div
          class="moneyItem"
          v-for="(item,index) in amountList"
          :key="index"
          :class="{active:index == isActive}"
          @click="showdifference(index,item)"
        >
          <div class="itemDiv">
            <div class="amount"><span style="font-size:14px;">
              ￥</span>{{item.price}}
              <span class="frequency" v-if="item.fee_way == 3">/{{item.count}}年</span>
            </div>
            <div class="frequency" v-if="item.fee_way == 0">{{item.count}}次</div>
            <div class="frequency" v-if="item.fee_way == 1">永久</div>
            <i
              class="el-icon-success"
              v-if="index == isActive"
            ></i>
          </div>
        </div>
      </div>
      <div class="SelectPackage">
        请选择AppKey：
      </div>
      <div>
        <el-select
          v-model="appKeyvalue"
          clearable
          placeholder="选择AppKey"
        >
          <el-option
            v-for="item in appKeyList"
            :key="item.value"
            :label="item.name"
            :value="item.app_key"
          >
          </el-option>
        </el-select>
        <span style="margin-left: 16px;color: rgba(0, 0, 0, 0.45);">还没选择AppKey？</span>
        <span
          @click="jumpApp"
          style="color: #0B4FFC;cursor: pointer;"
        >去创建</span>
      </div>
      <div class="Deduction">
        <span>本次需扣款：</span>
        <span style="color: #FF4D4F; margin-right: 16px;">¥{{Deduction}}</span>
        <span>当前余额：</span>
        <span style="color: #FF4D4F;">¥{{userList.money}}</span>
      </div>
      <div>
        <el-button
          plain
          @click="jumpPayPage"
        >去充值</el-button>
        <el-button
          type="danger"
          @click="jumpPay()"
        >立即支付</el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
import apis from "@/api/apis";
export default {
  name: 'OpenBuy',

  data () {
    return {
      options: [],
      value: [],
      restaurants: [],
      state1: '',
      isActive: 0,
      apiPackage: 1,
      page: 'list',
      apiKeyword: '',
      loading: false,
      appKeyList: [],
      appKeyvalue: '',
      amountList: [],
      Deduction: 500,
      money: '',
      userList: []
    };
  },
  watch:{
  },
  mounted () {
    this.getUserInfo()
  },
  methods: {
    //用户信息
    getUserInfo () {
      console.log(123);
      if (this.$route.query.buyApiId) {
        this.apiKeyword = Number(this.$route.query.buyApiId)
      }
      apis.index.useIndex().then(res => {
        this.userList = res.data.user
        console.log(res, "userList");
        this.getsearchApiList()
        this.getAppDetail()
      })
    },
    //模糊查询
    getSearch (e) {
      this.apiKeyword = e
      this.getsearchApiList()
    },
    //查询api
    getsearchApiList () {
      apis.index.searchApiList({
        q: this.apiKeyword,
      }).then(res => {
        this.restaurants = res.data.list
        this.options = this.restaurants
        this.restaurants.forEach(element => {
          if (!element.label) {
            element.label = element.title
          }
        });
        // if (!this.apiKeyword) {
          this.getRechargePackage()
        // }

      })

    },
    //查询套餐
    getRechargePackage () {
      let apiId = ''
      if (!this.apiKeyword) {
        apiId = this.restaurants[0] && this.restaurants[0].id
      } else {
        apiId = this.apiKeyword
      }
      apis.index.RechargePackage({
        api_id: apiId
      }).then(res => {
        this.amountList = res.data.package
        this.Deduction = this.amountList[0].price
      })
    },
    getAppDetail () {
      apis.app.index({
        page: 1,
        page_size: 100,
      }).then(res => {
        this.appKeyList = res.data.list

      })
    },
    // 选择余额
    showdifference (index, item) {
      console.log(item, "123456")
      this.isActive = index
      this.apiPackage = item.id
      this.Deduction = item.price
    },
    jumpPayPage () {
      this.page = "recharge"
      this.$router.push({
        name: 'ConsoleHome',
        params: {
          page: this.page
        }
      })

    },
    jumpApp () {
      this.$router.replace('/appManager')
    },
    jumpPay () {
      if (this.apiPackage && this.appKeyvalue && this.apiKeyword) {
        apis.index.payPackage({
          package_id: this.apiPackage,
          app_key: this.appKeyvalue,
          api_id: this.apiKeyword
        }).then(res => {
          if (res.code != 0) {
            this.$confirm(res.msg, {
              confirmButtonText: '确定',
              showCancelButton: false,
              type: 'success',
              showClose: false
            }).then(() => {
              this.$emit("watchson", this.page);
            })
          }
        })
      }
    },

  },
};
</script>
<style lang="scss" scoped>
::v-deep.el-menu {
  border: none;
}
.tips {
  margin-bottom: 16px;
  padding-left: 17px;
  line-height: 40px;
  height: 40px;
  background: #fffbe6;
  border-radius: 2px;
  border: 1px solid #ffe58f;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;

  color: rgba(0, 0, 0, 0.65);
  i {
    font-size: 16px;
    color: #faad14;
  }
}
.box-card {
  width: 100%;
  padding: 0 20px 20px 20px;
  .SelectPackage {
    margin: 16px 0 16px 0;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
  }
  .money {
    display: flex;
    flex-wrap: wrap;
    width: 700px;
    overflow: hidden;
    .moneyItem {
      margin-bottom: 16px;
      width: 212px;
      height: 86px;
      margin-right: 16px;
      background: #ffffff;
      border-radius: 2px;
      border: 1px solid #d9d9d9;
      display: flex;
      align-items: center;
      position: relative;
      cursor: pointer;
      .itemDiv {
        margin-left: 16px;
        .amount {
          font-size: 24px;
          font-family: HelveticaNeue-Medium, HelveticaNeue;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.85);
          .frequency{
            color: rgba(0, 0, 0, 0.85);
          }
        }
        .frequency {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.25);
        }
        i {
          position: absolute;
          top: 10px;
          right: 10px;
          font-size: 20px;
          color: #0b4ffc;
        }
      }
    }
    .active {
      color: #0b4ffc;
      border: 1px solid #0b4ffc;
      border-radius: 2px;
    }
  }
  .appKey {
    margin: 32px 0 16px 0;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
  }
  .Deduction {
    margin: 32px 0 16px 0;
    font-weight: bold;
    font-family: PingFangSC-Regular, PingFang SC;
  }
}
</style>